module.exports = __webpack_public_path__ + "static/media/ic_delete.cb0e80f5.svg";